module.exports = __webpack_public_path__ + "assets/img/zoom_reset_icon.41fad0d5.svg";